import { useMemo } from 'react';

import { useFirmsRetrieveQuery } from '@/services/api/generated/firmsService';
import {
  type MiniTortClaimDetailSchema,
  useMiniTortClaimListQuery,
  useMiniTortClaimRetrieveQuery,
} from '@/services/api/generated/miniTortService';

export function useMiniTortClaim(matterId: string | undefined, firmId: string | undefined) {
  const { data: firmData, isLoading: isFirmLoading } = useFirmsRetrieveQuery({ id: firmId ?? '' }, { skip: !firmId });
  const isMiniTortFirm = firmData?.is_mini_tort === true;

  const { data: claimsData, isLoading: isClaimsLoading } = useMiniTortClaimListQuery(
    { limit: 50, ordering: '-created_at' }, { skip: !isMiniTortFirm || !matterId },
  );
  const matchedClaimId = useMemo(() => {
    if (!claimsData || !matterId) return undefined;
    return claimsData.results.find((c) => c.matter_id === matterId)?.id;
  }, [claimsData, matterId]);

  const { data: claim, isLoading: isDetailLoading } = useMiniTortClaimRetrieveQuery(
    { id: matchedClaimId ?? '' }, { skip: !matchedClaimId },
  );

  return {
    isMiniTortMatter: isMiniTortFirm,
    claim: claim as MiniTortClaimDetailSchema | undefined,
    isLoading: isFirmLoading || (isMiniTortFirm && (isClaimsLoading || (!!matchedClaimId && isDetailLoading))),
  };
}
